import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { RPCFactory } from '../../../../utils/RequestUtil';

const mapStateToProps = (state) => ({ ...state.leadsManage });

class WechatTab extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      bindingState: 0,
      codeUrl: '',
      showDelateConfig: false,
      eventTarget: null,
    };
  }

  componentDidMount() {
    this.getBindingState();
  }

  getBindingState = () => {
    RPCFactory.accountSettings.getBindingState().done((data) => {
      this.setState({ bindingState: data.boundState });
      this.getQRCode();
    });
  };

  getQRCode = () => {
    RPCFactory.accountSettings.createQRCode().done((data) => {
      this.setState({ codeUrl: data.qrCodeUrl });
    });
  };

  handleDelateClose = () => {
    this.setState({
      showDelateConfig: false,
    });
  };

  showDelateConfigDialog = (event) => {
    this.setState({
      showDelateConfig: true,
      eventTarget: event.target,
    });
  };

  delateSubmit = () => {
    RPCFactory.accountSettings.unBindWeChat().done((data) => {
      this.setState({
        showDelateConfig: false,
      });
      this.getBindingState();
    });
  };

  render() {
    return (
      <div className="secs">
        <div className="sec">
          <div className="card">
            <div className="panel erweima-set">
              <div className="panel-heading">
                <p className="panel-title">微信提醒设置</p>
                <div>
                  <div className="text">
                    您可以通过扫码二维码关注“腾讯广告线索管理”公众号，系统会对（超级）管理员发送线索到达提醒，对线索归属人发送线索分配提醒（提醒频率：15分钟/次）。您也可以将此二维码复制分享给其他员工（需保证已在“员工管理”中录入信息）扫描绑定消息提示。
                  </div>
                  <div className="erweima">
                    <div className="erweima-img">
                      <img src={this.state.codeUrl} alt="" />
                    </div>
                    <div className="erweima-tip">
                      <p>扫码绑定公众号</p>
                      <p>在公众号中管理线索数据</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const wechatTab = withRouter(connect(mapStateToProps)(WechatTab));
export default wechatTab;
